











































































































































































































































































import {
  LabelQualityGoal,
  QualityGoalType,
} from '@/interfaces/types/QualityGoal';
import { calcArraySimilarity } from '@/utils/array';
import { formatDateToString } from '@/utils/formatter';
import Vue, { PropType } from 'vue';

type ReportHelperType = LabelQualityGoal & {
  methodStr: string;
  goalHeaders: string[];
  goalValues: string[];
  resultHeaders: string[];
  resultValues: string[];
};

export default Vue.extend({
  props: {
    labelsetName: {
      type: String,
    },
    labelsetDescription: {
      type: String,
    },
    labelsetDate: {
      type: String,
    },
    qualityGoal: { type: Object as PropType<QualityGoalType> },
  },
  data(): {
    corruptedFileRate: number;
    hasDataset: boolean;
    extensions: string;
    labelGoalList: ReportHelperType[];
    badDataNumber: number;
  } {
    // 파일 분석 관련 데이터 생성
    let corruptedFileRate = 0;
    let extensions = '';
    const hasDataset = !!this.$store.getters.fileAnalyses;
    let badDataNumber = 0;
    if (hasDataset) {
      badDataNumber = this.$store.getters.badDataNumber;
      const totalDataNumber = this.$store.getters.totalDataNumber;
      corruptedFileRate = 100 * (badDataNumber / totalDataNumber);

      const extensionDist = this.$store.getters.extensionDistribution ?? [];

      let i = 0;
      let len = Object.keys(extensionDist).length;
      for (const ext in extensionDist) {
        i++;
        extensions += `${ext}(${(
          100 *
          (extensionDist[ext] / totalDataNumber)
        ).toFixed(2)}%)`;
        if (i !== len) extensions += ', ';
      }
    }

    return {
      hasDataset: hasDataset,
      corruptedFileRate: corruptedFileRate,
      extensions: extensions,
      labelGoalList: [],
      badDataNumber: badDataNumber,
    };
  },
  computed: {
    labelsetCreatedAt(): string {
      return formatDateToString(new Date(this.labelsetDate));
    },
    schemaCompRate(): number {
      const schemaAnalysisResult = this.$store.getters.schemaAnalysisResult;
      const badLabelNumber = schemaAnalysisResult.badLabelNumber;
      const totalLabelNumber = schemaAnalysisResult.totalLabelNumber;

      return 100 * (1 - badLabelNumber / totalLabelNumber);
    },
    labelNumber(): number {
      const schemaAnalysisResult = this.$store.getters.schemaAnalysisResult;
      return schemaAnalysisResult.totalLabelNumber;
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    qualityGoalLabelAnalysisResultWatcher(): any {
      return {
        ...this.qualityGoal,
        ...this.$store.getters.labelAnalysisResult,
      };
    },
  },
  watch: {
    qualityGoalLabelAnalysisResultWatcher: {
      immediate: true,
      deep: true,
      handler() {
        // #region 요약 리포트에 사용할 labelGoalList 정제
        const labelGoalList = [];
        const labelAnalysisResult = this.$store.getters.labelAnalysisResult;
        const labelQualityGoal = this.qualityGoal.qualityGoal.labelQualityGoal;

        for (const key in labelQualityGoal) {
          const goal = labelQualityGoal[key];

          if (goal.target === undefined) {
            continue;
          }

          const labelResult = labelAnalysisResult[goal.target];

          // 리포트 필요 데이터 정제해 리스트에 추가
          /** Report Information Payload */
          const RIP: ReportHelperType = {
            ...goal,
            methodStr: '',
            goalHeaders: [],
            goalValues: [],
            resultHeaders: [],
            resultValues: [],
          };

          switch (RIP.method) {
            case 'arrElCnt':
              RIP.methodStr = '배열 당 요소 건수';
              RIP.goalValues.push(`${RIP.elementCount?.toLocaleString()}`);
              RIP.resultValues.push(
                `${
                  !labelResult || !labelResult.element_count
                    ? `분석 데이터 없음`
                    : labelResult.element_count.toLocaleString()
                }`,
              );
              break;
            case 'arrLenMinAvgMax':
              RIP.methodStr = '배열 길이 범위';
              if (RIP.minValue) {
                RIP.goalHeaders.push('최소');
                RIP.resultHeaders.push('최소');
                RIP.goalValues.push(`${RIP.minValue.toLocaleString()}`);
                RIP.resultValues.push(
                  `${
                    !labelResult || !labelResult.min_length
                      ? `분석 데이터 없음`
                      : labelResult.min_length.toLocaleString()
                  }`,
                );
              }
              if (RIP.average) {
                RIP.goalHeaders.push('평균');
                RIP.resultHeaders.push('평균');
                RIP.goalValues.push(`${RIP.average.toLocaleString()}`);
                RIP.resultValues.push(
                  `${
                    !labelResult || !labelResult.mean_length
                      ? `분석 데이터 없음`
                      : labelResult.mean_length.toLocaleString()
                  }`,
                );
              }
              if (RIP.maxValue) {
                RIP.goalHeaders.push('최대');
                RIP.resultHeaders.push('최대');
                RIP.goalValues.push(`${RIP.maxValue.toLocaleString()}`);
                RIP.resultValues.push(
                  `${
                    !labelResult || !labelResult.max_length
                      ? `분석 데이터 없음`
                      : labelResult.max_length.toLocaleString()
                  }`,
                );
              }
              break;
            case 'classQuantity':
              RIP.methodStr = '클래스 별 건수';
              if (RIP.classes && RIP.classQuantity) {
                if (!labelResult || !labelResult.class_counts) {
                  for (const key in RIP.classes) {
                    RIP.goalHeaders.push(key);
                    RIP.resultHeaders.push(RIP.classes[key]);
                    RIP.goalValues.push(
                      `${RIP.classQuantity[key].toLocaleString()}건`,
                    );
                    RIP.resultValues.push(`분석 데이터 없음`);
                  }
                } else {
                  for (const key in RIP.classes) {
                    RIP.goalHeaders.push(key);
                    RIP.resultHeaders.push(RIP.classes[key]);
                    RIP.goalValues.push(
                      `${RIP.classQuantity[key].toLocaleString()}건`,
                    );
                    RIP.resultValues.push(
                      `${(RIP.classes[key] &&
                      labelResult.class_counts[RIP.classes[key]]
                        ? labelResult.class_counts[RIP.classes[key]]
                        : 0
                      ).toLocaleString()}건`,
                    );
                  }
                  // get ETC values
                  const etcHeaders = [];
                  const etcValues = [];
                  let etcSum = 0;
                  for (const key in labelResult.class_counts) {
                    if (!RIP.resultHeaders.includes(key)) {
                      etcHeaders.push(key);
                      etcValues.push(
                        `${labelResult.class_counts[key].toLocaleString()}건`,
                      );
                      etcSum += labelResult.class_counts[key];
                    }
                  }
                  if (RIP.reportOption?.showEtc && etcHeaders.length > 0) {
                    RIP.resultHeaders.push('기타');
                    RIP.resultValues.push(`${etcSum.toLocaleString()}건`);
                  } else {
                    RIP.resultHeaders.push(...etcHeaders);
                    RIP.resultValues.push(...etcValues);
                  }
                }
              }
              break;
            case 'dist':
              RIP.methodStr = '클래스 분포';
              if (RIP.classes && RIP.distributionRate) {
                const total = Object.keys(RIP.distributionRate).reduce(
                  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                  (pv: number, key) => pv + RIP.distributionRate![key],
                  0,
                );
                if (!labelResult || !labelResult.class_counts) {
                  for (const key in RIP.classes) {
                    RIP.goalHeaders.push(key);
                    RIP.resultHeaders.push(RIP.classes[key]);
                    RIP.goalValues.push(
                      `${((100 * RIP.distributionRate[key]) / total).toFixed(
                        2,
                      )}%`,
                    );
                    RIP.resultValues.push(`분석 데이터 없음`);
                  }
                } else {
                  for (const key in RIP.classes) {
                    RIP.goalHeaders.push(key);
                    RIP.resultHeaders.push(RIP.classes[key]);
                    RIP.goalValues.push(
                      `${((100 * RIP.distributionRate[key]) / total).toFixed(
                        2,
                      )}%`,
                    );

                    RIP.resultValues.push(
                      `${(labelResult.count > 0 &&
                      RIP.classes[key] &&
                      labelResult.class_counts[RIP.classes[key]]
                        ? (100 * labelResult.class_counts[RIP.classes[key]]) /
                          labelResult.count
                        : 0
                      ).toFixed(2)}%`,
                    );
                  }
                  // get ETC values
                  const etcHeaders = [];
                  const etcValues = [];
                  let etcSum = 0;
                  for (const key in labelResult.class_counts) {
                    if (!RIP.resultHeaders.includes(key)) {
                      etcHeaders.push(key);
                      etcValues.push(
                        `${(
                          (100 * labelResult.class_counts[key]) /
                          labelResult.count
                        ).toFixed(2)}%`,
                      );
                      etcSum += labelResult.class_counts[key];
                    }
                  }
                  if (RIP.reportOption?.showEtc && etcHeaders.length > 0) {
                    RIP.resultHeaders.push('기타');
                    RIP.resultValues.push(
                      `${((100 * etcSum) / labelResult.count).toFixed(2)}%`,
                    );
                  } else {
                    RIP.resultHeaders.push(...etcHeaders);
                    RIP.resultValues.push(...etcValues);
                  }

                  if (RIP.reportOption?.showStandard) {
                    RIP.resultHeaders.push('구성비중첩률');
                    RIP.resultValues.push(
                      `${(
                        100 *
                        calcArraySimilarity(
                          RIP.goalValues.map((v) => parseFloat(v)),
                          RIP.resultValues.map((v) => parseFloat(v)),
                        )
                      ).toFixed(2)}%`,
                    );
                  }
                }
              }
              break;
            case 'minAvgMax':
              RIP.methodStr = '수치 범위';
              if (RIP.minValue) {
                RIP.goalHeaders.push('최소');
                RIP.resultHeaders.push('최소');
                RIP.goalValues.push(`${RIP.minValue.toLocaleString()}`);
                RIP.resultValues.push(
                  `${
                    !labelResult || !labelResult.min
                      ? `분석 데이터 없음`
                      : labelResult.min.toLocaleString()
                  }`,
                );
              }
              if (RIP.average) {
                RIP.goalHeaders.push('평균');
                RIP.resultHeaders.push('평균');
                RIP.goalValues.push(`${RIP.average.toLocaleString()}`);
                RIP.resultValues.push(
                  `${
                    !labelResult || !labelResult.mean
                      ? `분석 데이터 없음`
                      : labelResult.mean.toLocaleString()
                  }`,
                );
              }
              if (RIP.maxValue) {
                RIP.goalHeaders.push('최대');
                RIP.resultHeaders.push('최대');
                RIP.goalValues.push(`${RIP.maxValue.toLocaleString()}`);
                RIP.resultValues.push(
                  `${
                    !labelResult || !labelResult.max
                      ? `분석 데이터 없음`
                      : labelResult.max.toLocaleString()
                  }`,
                );
              }
              break;
            default:
              break;
          }

          labelGoalList.push(RIP);
        }
        // #endregion

        this.labelGoalList = labelGoalList;
      },
    },
  },
});
